"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../../helpers");
exports.MIN_WIDTH_TAG_INPUT = helpers_1.FIELD_M;
exports.DEFAULT_TEXTS = {
    placeholderWithSuggest: 'Enter tag or choose from the list...',
    placeholderWithoutSuggest: 'Enter tag...'
};
//# sourceMappingURL=helpers.js.map